import { createFileRoute, redirect } from '@tanstack/react-router';

type LegacyTimelineBeforeLoadArgs = {
  params: { loopId: number; org: string; viewId: number };
};

export const legacyTimelineBeforeLoad = ({ params }: LegacyTimelineBeforeLoadArgs): never => {
  throw redirect({
    to: '/org/$org/loop/$loopId/portfolio/view/$viewId/roadmap',
    params,
    search: true,
    replace: true,
  });
};

export const Route = createFileRoute(
  '/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/timeline/',
)({
  beforeLoad: legacyTimelineBeforeLoad,
});
